export class IReviewRemark {
    reviewStatus?: string;
    reviewRemark?: string;
    reviewRemarkFirstPart?: string;
    reviewRemarkLastPart?: string;
}
